<template>
	<layout-page title="Help">
		<!-- title -->
		<div
			class="bg-green px-4 sm:px-6 py-4 lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
		>
			<h1 class="text-2xl md:text-4xl font-semibold text-white">Hilfe</h1>
		</div>

		<div
			class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-6"
		>
			<h2 class="text-2xl font-semibold">Wie können wir Ihnen helfen?</h2>

			<div class="rounded-xl bg-white shadow">
				<!-- py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24 -->
				<div class="mx-auto pt-4 pb-8 lg:py-12 px-4 sm:px-6 lg:px-8">
					<div class="grid grid-cols-1 gap-12 lg:grid-cols-3 lg:gap-8">
						<div class="space-y-5 sm:space-y-8">
							<p class="text-lg text-gray-500">
								Benötigen Sie Unterstützung, haben Sie Fragen oder eine Idee wie
								wir cropspot optimieren können?
							</p>
							<h2
								class="text-3xl font-semibold tracking-tight sm:text-4xl text-gray-900"
							>
								Kontaktieren Sie uns
							</h2>
						</div>
						<div class="lg:col-span-2">
							<ul
								role="list"
								class="space-y-8 sm:grid sm:grid-cols-2 sm:gap-8 sm:space-y-0 lg:gap-x-8"
							>
								<li>
									<div class="flex items-center space-x-4 lg:space-x-6">
										<img
											class="w-16 h-16 rounded-full lg:w-20 lg:h-20"
											:src="imageMax"
											alt
										/>
										<div class="font-medium leading-6 space-y-1">
											<h3 class="text-gray-900 text-lg">
												Maximilian von Weichs
											</h3>
											<p class="text-gray-700">+49 (0) 172 1011 622</p>
											<a
												href="mailto:m.weichs@cropspot.com"
												class="text-orange-500"
												>m.weichs@cropspot.com</a
											>
										</div>
									</div>
								</li>
								<li>
									<div class="flex items-center space-x-4 lg:space-x-6">
										<img
											class="w-16 h-16 rounded-full lg:w-20 lg:h-20"
											:src="imageTobi"
											alt
										/>
										<div class="font-medium leading-6 space-y-1">
											<h3 class="text-gray-900 text-lg">Tobias Fallmeier</h3>
											<p class="text-gray-700">+49 (0) 172 1011 633</p>
											<a
												href="mailto:t.fallmeier@cropspot.com"
												class="text-orange-500"
												>t.fallmeier@cropspot.com</a
											>
										</div>
									</div>
								</li>
								<!--                                 <li>
                                    <div class="flex items-center space-x-4 lg:space-x-6">
                                        <img
                                            class="w-16 h-16 rounded-full lg:w-20 lg:h-20"
                                            src="https://www.cropspot.com/assets/images/team/tobi.jpg"
                                            alt
                                        />
                                        <div class="font-medium leading-6 space-y-1">
                                            <h3 class="text-gray-900 text-lg">Tobias Fallmeier</h3>
                                            <p class="text-gray-700">+49 (0) 172 1011 633</p>
                                            <a href="mailto:t.fallmeier@cropspot.com" class="text-orange-500">t.fallmeier@cropspot.com</a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="flex items-center space-x-4 lg:space-x-6">
                                        <img
                                            class="w-16 h-16 rounded-full lg:w-20 lg:h-20"
                                            src="https://www.cropspot.com/assets/images/team/friederike.jpg"
                                            alt
                                        />
                                        <div class="font-medium leading-6 space-y-1">
                                            <h3 class="text-gray-900 text-lg truncate">Friederike von Grawert</h3>
                                            <p class="text-gray-700">+49 (0)173-7114971</p>
                                            <a href="mailto:j.meyer@cropspot.com" class="text-orange-500">f.grawert@cropspot.com</a>
                                        </div>
                                    </div>
                                </li> -->
							</ul>
						</div>
					</div>
				</div>
			</div>

			<h2 class="text-2xl font-semibold">Häufig gestellte Fragen</h2>

			<div class="rounded-xl bg-white shadow divide-y divide-gray-200">
				<dl class="divide-y divide-gray-200">
					<ui-accordion-item
						class="p-4 text-lg"
						v-for="(faq, index) in faqItems"
						:key="faq.q"
					>
						<template v-slot:button="slotProps">
							<dt
								class="text-left w-full flex justify-between items-start text-gray-400"
							>
								<span class="font-medium text-gray-900" v-html="faq.q"></span>
								<span class="ml-6 h-7 flex items-center">
									<ui-icon
										class="rotate-0 h-6 w-6 transform"
										:name="slotProps.open ? 'chevron-up' : 'chevron-down'"
										stroke-width="2"
									/>
								</span>
							</dt>
						</template>
						<template>
							<dd
								class="mt-2 pr-12 text-base text-gray-500"
								v-html="faq.a"
							></dd>
						</template>
					</ui-accordion-item>
				</dl>
			</div>
		</div>
	</layout-page>
</template>

<script>
let faqItems = {
	de: [
		{
			q: "Wer kann sich bei cropspot anmelden?",
			a: "cropspot richtet sich an alle Unternehmen der landwirtschaftlichen Wertschöpfungskette, vom Erzeuger bzw. Veredelungsbetrieb über den Landhandel bis hin zur verarbeitenden Industrie. Dabei spielen sowohl für Käufer als auch Verkäufer Betriebsgröße oder Handelsvolumen keine Rollen.",
		},
		{
			q: "Welche technischen Voraussetzungen müssen für die Nutzung erfüllt sein?",
			a: "Für die Nutzung von cropspot bedarf es lediglich eines internetfähigen Endgerätes. Dies schließt eine mobile Version für Smartphones & Tablets ein.",
		},
		{
			q: "Was kostet die Nutzung?",
			a: 'Neben einer kostenfreien Registrierung stellt cropspot auch Marktinformationen und Futures frei zur Verfügung. Für einen erfolgreichen Geschäftsabschluss erheben wir eine Vermittlungsgebühr pro gehandelter Tonne. Details entnehemen Sie bitte unserer <a href="https://www.cropspot.com/preise.pdf" class="text-orange-500">Gebührenordnung</a>',
		},
		{
			q: "Wann muss ich die Vermittlungsgebühr bezahlen?",
			a: "Die Vermittlungsgebühr wird Ihnen nach Kontraktabschluss von cropspot konsolidiert am Monatsende in Rechnung gestellt. Das Zahlungsziel ist binnen 14 Tagen nach Erhalt der Rechnung.",
		},
		{
			q: "Wie funktioniert der Handel auf cropspot?",
			a: "Registrierte Nutzer stellen ihr individuelles Kauf- oder Verkaufsinteresse gezielt ein und bekommen automatisch passende Partien angezeigt. Über die Suchfunktionen finden Käufer und Verkäufer zueinander, die unter anderem nach Produkten, Terminen und Erfüllungsorten filtern können. Die Verhandlung und Abwicklung erfolgt in einem Chat.",
		},
		{
			q: "Wofür benötige ich die SMS-Benachrichtigung?",
			a: "Sie werden bei neuen Geboten oder Offerten informiert. Es werden keine werblichen SMS verschickt.",
		},
		{
			q: "Ich habe mehrere Betriebsstandorte, wie kann ich diese auf cropspot differenzieren?",
			a: "Cropspot bietet Ihnen die Möglichkeit über eine Mandantenfunktion verschieden Betriebe in einem Account zu bündeln und zu verwalten. Für die Einrichtung sprechen Sie uns gerne an.",
		},
		{
			q: "Was ist der Unterschied zwischen „Franko“ und „frei Fuhre“?",
			a: "Grundsätzlich bedeutet „Franko“ immer geliefert Zielort. Das heißt der Verkäufer trägt das Frachtrisiko und die Frachtkosten. „Frei Fuhre“ bedeutet hingegen, dass die Ware freiverladen LKW auf dem Betrieb erworben wird.",
		},
		{
			q: "Was passiert nach einem Kontraktabschluss?",
			a: "Nach einem erfolgreichen Kontraktabschluss finden Sie in dem zugehörigen Chat unter dem Reiter „Verhandlung & Abwicklung“ den entsprechenden Schlussschein/Kontrakt zur Einsicht und zum Download. Mittels des zur Verfügung stehenden Chats oder über die einsehbaren Kontaktdaten ihres Geschäftspartners können Sie das weitere Vorgehen bezüglich Lieferung oder Abholung der Ware abstimmen",
		},
		{
			q: "Wie kann ich cropspot mobil nutzen?",
			a: 'Folgen Sie der Anleitung für <a href="https://app.cropspot.com/documents/cropspot_mobil_Android.pdf" class="underline">Android</a> bzw. <a href="https://app.cropspot.com/documents/cropspot_mobil_iOS.pdf" class="underline">iPhone/iPad</a>.',
		},
	],
};
export default {
	props: {},
	data() {
		return {
			faqItems: faqItems["de"], // TODO make conditional locale once content is here
		};
	},
	computed: {
		imageTobi: () => window.baseUrl + "/images/tobi-rounded.jpg",
		imageMax: () => window.baseUrl + "/images/max-rounded.jpg",
	},
};
</script>
